/* Lampiero v3: small, dependency-free behaviours. Every block guards itself, so one failure never stops the rest. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, fn, root) { [].forEach.call((root || d).querySelectorAll(sel), function (el) { try { fn(el); } catch (e) { if (w.console) console.warn('lv', sel, e); } }); }
  function onView(el, fn, th) {
    if (!('IntersectionObserver' in w)) { fn(); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); fn(); } }, { threshold: th || 0.35 });
    io.observe(el);
  }
  var ticking = [], raf = 0;
  function onScroll(fn) { ticking.push(fn); }
  function loop() { raf = 0; ticking.forEach(function (f) { try { f(); } catch (e) {} }); }
  w.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(loop); }, { passive: true });
  w.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(loop); }, { passive: true });

  /* anchor target that is really on screen (Sense hides empty divs) */
  function target(id) {
    var t = d.getElementById(id);
    if (!t) return null;
    var r = t.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) t = t.closest('.product__info-container, section, .shopify-section') || t;
    return t;
  }
  function go(t) {
    if (!t) return;
    var y = t.getBoundingClientRect().top + w.pageYOffset - 76;
    w.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  }
  w.lvGo = function (id) { go(target(id)); };
  /* v5: every "See the offer / Choose your set" lands on the sets and the button, not on the gallery above them */
  function offer() { return d.querySelector('kaching-bundles-block') || d.querySelector('.lv-multi') || target('lv-offer'); }
  /* v10: the language is the shop language (Shopify languages: <html lang> is en, de, pt-PT ...). The words come from
     window.LV_T (snippets/lv-t, theme locale files); the English here is only a fallback. */
  function langFull() { return ((d.documentElement.lang || '').trim() || 'en'); }
  function lang() { return langFull().slice(0, 2).toLowerCase(); }
  var T = w.LV_T || {};
  /* a word from LV_T, unless it is still the English one on a page in another language (not translated yet) */
  function tr(k, en) { var v = T[k]; return (typeof v === 'string' && v && (v !== en || lang() === 'en')) ? v : null; }
  function root() { return (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/'; }
  /* dates: "Thu 8 Oct" in English (no comma), the visitor's own language otherwise.
     lv11: pl, cs, sk, el, pt, bg, lt, hr and fi print the month as a word in its date form ("19 października", "19. října",
     "19 de outubro"), not "paź" or the numeric "19. 10." / "19/10". noMonth: the first date of a range in the same month
     drops its month ("lun. 19 et le ven. 23 oct.", "Mo., 19. und Fr., 23. Okt."); languages that write the month first keep it. */
  var LV11_LONG = { pl: 1, cs: 1, sk: 1, el: 1, pt: 1, bg: 1, lt: 1, hr: 1, fi: 1 };
  function dopt() { return { weekday: 'short', day: 'numeric', month: LV11_LONG[lang()] ? 'long' : 'short' }; }
  function day(t, noMonth) {
    var l = lang();
    if (l === 'en') return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][t.getDay()] + ' ' + t.getDate() + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][t.getMonth()];
    try {
      if (noMonth && w.Intl && Intl.DateTimeFormat.prototype.formatToParts) {
        var p = new Intl.DateTimeFormat(langFull(), dopt()).formatToParts(t), im = -1, id = -1, out = '';
        for (var i = 0; i < p.length; i++) { if (p[i].type === 'month') im = i; if (p[i].type === 'day') id = i; }
        if (id > -1 && im > id) {
          for (var j = 0; j < im - 1; j++) out += p[j].value;
          /* the literal before the month: keep only its leading dot ("19." in de, cs, da), drop " ", " de ", ". " */
          out += p[im - 1].type === 'literal' ? (p[im - 1].value.match(/^\.*/) || [''])[0] : p[im - 1].value;
          return out;
        }
      }
      return t.toLocaleDateString(langFull(), dopt());
    } catch (e) { return t.toDateString().slice(0, 10); }
  }

  /* 1. product gallery: swipe deck with counter, dots, thumbs, arrows */
  each('[data-lv-gal]', function (g) {
    var track = g.querySelector('.lv-gal__track');
    var slides = track ? track.children : [];
    var n = slides.length, cur = 0;
    var thumbs = g.querySelectorAll('.lv-gal__thumb');
    var count = g.querySelector('.lv-gal__count');
    var dots = g.querySelector('.lv-gal__dots');
    if (dots && !dots.children.length) for (var i = 0; i < n; i++) dots.appendChild(d.createElement('i'));
    function set(i) {
      cur = i;
      [].forEach.call(thumbs, function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (dots) [].forEach.call(dots.children, function (t, k) { t.className = k === i ? 'is-on' : ''; });
      if (count) count.textContent = (i + 1) + ' / ' + n;
      var t = thumbs[i];
      if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
    }
    /* v9 R4: scroll to the slide's own position (slides can be a fraction of a pixel wider than the track's rounded width,
       so i * clientWidth drifted and left a 1 px strip of the previous picture at the edge) */
    function to(i) { i = Math.max(0, Math.min(n - 1, i)); var s = slides[i], s0 = slides[0]; track.scrollTo({ left: s && s0 ? s.offsetLeft - s0.offsetLeft : i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    /* v9 R4: the track gets a whole-pixel width, so every slide starts on a whole pixel and no strip of the neighbouring
       picture can show at the edge (seen at 1900 px wide: a 1 px white line left of the "30 nights" card) */
    function fitW() {
      track.style.width = '';
      var wd = track.getBoundingClientRect().width;
      if (wd % 1) track.style.width = Math.floor(wd) + 'px';
    }
    fitW();
    if ('ResizeObserver' in w) { var rf = 0; new ResizeObserver(function () { cancelAnimationFrame(rf); rf = requestAnimationFrame(function () { var k = cur; fitW(); track.scrollLeft = slides[k] ? slides[k].offsetLeft - slides[0].offsetLeft : 0; }); }).observe(g.querySelector('.lv-gal__frame') || track); }
    var r2;
    track.addEventListener('scroll', function () { cancelAnimationFrame(r2); r2 = requestAnimationFrame(function () { set(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }); }, { passive: true });
    [].forEach.call(thumbs, function (t, k) { t.addEventListener('click', function () { to(k); }); });
    var p = g.querySelector('.lv-gal__nav--p'), nx = g.querySelector('.lv-gal__nav--n');
    p && p.addEventListener('click', function () { to(cur - 1); });
    nx && nx.addEventListener('click', function () { to(cur + 1); });
    set(0);
  });

  /* 2. before / after slider (v5 rewrite).
     Why: in v3/v4 grabbing the round handle ended the drag after one move (the handle lost its implicit touch
     capture, "lostpointercapture" bubbled up and stopped the drag), and every move re-laid out the page.
     Now: the handle drags at once, a sideways swipe anywhere on the picture drags too, a tap jumps there,
     vertical swipes still scroll the page, and painting is one rAF per frame with transforms only. */
  each('[data-lv-ba]', function (el) {
    var before = el.querySelector('.lv-ba__before');
    var rail = el.querySelector('.lv-ba__rail');
    var handle = el.querySelector('.lv-ba__handle');
    var val = 50, raf = 0, drag = null, anim = 0, touched = false, rect = null;
    function paint() {
      raf = 0;
      var r = (100 - val).toFixed(3) + '%';
      if (before) { before.style.clipPath = 'inset(0 ' + r + ' 0 0)'; before.style.webkitClipPath = 'inset(0 ' + r + ' 0 0)'; }
      if (rail) rail.style.transform = 'translate3d(' + val.toFixed(3) + '%,0,0)';
      if (handle) handle.setAttribute('aria-valuenow', Math.round(val));
    }
    function set(v) { val = Math.max(0, Math.min(100, v)); if (!raf) raf = requestAnimationFrame(paint); }
    function pct(x) { return (x - rect.left) / Math.max(1, rect.width) * 100; }
    function stopAnim() { if (anim) cancelAnimationFrame(anim); anim = 0; }
    function tween(to, ms) {
      stopAnim(); var from = val, t0 = performance.now();
      (function f(now) { var t = Math.min(1, (now - t0) / ms), e = 1 - Math.pow(1 - t, 3); set(from + (to - from) * e); anim = t < 1 ? requestAnimationFrame(f) : 0; })(t0);
    }
    el.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
      stopAnim(); touched = true; rect = el.getBoundingClientRect();
      var onHandle = !!(e.target.closest && e.target.closest('.lv-ba__handle'));
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, v: val, handle: onHandle, mode: (onHandle || e.pointerType !== 'touch') ? 'h' : 'wait' };
      if (drag.mode === 'h') {
        el.classList.add('is-drag');
        if (e.pointerType !== 'touch') { try { el.setPointerCapture(e.pointerId); } catch (er) {} }
        if (!onHandle) set(pct(e.clientX));
        if (e.pointerType !== 'touch') e.preventDefault();
      }
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (drag.mode === 'wait') {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; } /* a vertical swipe: let the page scroll */
        drag.mode = 'h'; el.classList.add('is-drag');
      }
      if (drag.mode === 'h') {
        if (e.cancelable) e.preventDefault();
        set(drag.handle ? drag.v + dx / Math.max(1, rect.width) * 100 : pct(e.clientX));
      }
    }, { passive: false });
    function end(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      if (drag.mode === 'wait' && e && e.type === 'pointerup') tween(pct(e.clientX), 260); /* a tap jumps there */
      drag = null; el.classList.remove('is-drag');
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('lostpointercapture', function (e) { if (e.target === el) end(e); });
    /* iOS: stop the page from scrolling sideways while dragging the handle */
    handle && handle.addEventListener('touchmove', function (e) { if (drag && drag.mode === 'h' && e.cancelable) e.preventDefault(); }, { passive: false });
    handle && handle.addEventListener('focus', function () { stopAnim(); touched = true; });
    handle && handle.addEventListener('keydown', function (e) {
      var k = e.key, v = val;
      if (k === 'ArrowLeft' || k === 'ArrowDown') v -= 5; else if (k === 'ArrowRight' || k === 'ArrowUp') v += 5; else if (k === 'Home') v = 0; else if (k === 'End') v = 100; else return;
      e.preventDefault(); stopAnim(); touched = true; set(v);
    });
    var start = parseFloat(el.getAttribute('data-start')) || 50;
    set(start);
    /* one gentle nudge the first time it comes into view, so people see it moves */
    if (!reduce) onView(el, function () {
      if (touched) return;
      setTimeout(function () {
        if (touched) return;
        var pts = start === 50 ? [50, 36, 64, 50] : [start, 18, start - 6], i = 0;
        (function next() { if (touched || i >= pts.length - 1) return; i++; tween(pts[i], 520); setTimeout(next, 560); })();
      }, 350);
    }, 0.55);
  });

  /* 3. light switch: big light, warm lamp, red */
  each('[data-lv-sw]', function (el) {
    var opts = [].slice.call(el.querySelectorAll('.lv-sw__opt'));
    var imgs = [].slice.call(el.querySelectorAll('.lv-sw__media img'));
    var caps = [].slice.call(el.querySelectorAll('.lv-sw__cap'));
    var used = false;
    el.addEventListener('focusin', function () { used = true; });
    el.addEventListener('pointerdown', function () { used = true; });
    function set(i, focus) {
      opts.forEach(function (o, k) { o.setAttribute('aria-checked', k === i ? 'true' : 'false'); o.tabIndex = k === i ? 0 : -1; });
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      el.style.setProperty('--i', i);
      el.style.setProperty('--amb', opts[i].getAttribute('data-amb'));
      var tc = opts[i].style.getPropertyValue('--t'), cc = opts[i].style.getPropertyValue('--c');
      if (tc) el.style.setProperty('--tint', tc);
      if (cc) el.style.setProperty('--glowc', cc);
      el.setAttribute('data-state', i);
      el.setAttribute('data-red', (i === opts.length - 1 || opts[i].getAttribute('data-red') === '1') ? '1' : '0');
      caps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      if (focus) opts[i].focus();
    }
    opts.forEach(function (o, k) {
      o.addEventListener('click', function () { used = true; set(k); });
      o.addEventListener('keydown', function (e) {
        var i = opts.indexOf(o);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); used = true; set((i + 1) % opts.length, true); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); used = true; set((i + opts.length - 1) % opts.length, true); }
      });
    });
    /* drag the knob along the track */
    var track = el.querySelector('.lv-sw__track'), dragging = null;
    track && track.addEventListener('pointerdown', function (e) { if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return; dragging = { x: e.clientX, y: e.clientY, h: false, id: e.pointerId }; });
    track && track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== dragging.id) return;
      if (!dragging.h) { if (Math.abs(e.clientX - dragging.x) < 8) return; if (Math.abs(e.clientY - dragging.y) > Math.abs(e.clientX - dragging.x)) { dragging = null; return; } dragging.h = true; try { track.setPointerCapture(dragging.id); } catch (er) {} }
      /* v9: the options can sit in a grid, so the option under the finger wins (not a slice of the width) */
      var hit = d.elementFromPoint(e.clientX, e.clientY), ho = hit && hit.closest ? hit.closest('.lv-sw__opt') : null;
      var i = ho ? opts.indexOf(ho) : -1;
      if (i < 0) return;
      used = true; set(i);
    });
    function endTrack(e) { if (dragging && e.pointerId === dragging.id) dragging = null; }
    track && track.addEventListener('pointerup', endTrack);
    track && track.addEventListener('pointercancel', endTrack);
    track && track.addEventListener('lostpointercapture', function (e) { if (e.target === track) endTrack(e); });
    set(0);
    if (!reduce) onView(el, function () {
      for (var st = 1; st < opts.length; st++) (function (k) { setTimeout(function () { if (!used) set(k); }, 1400 * k); })(st);
    }, 0.55);
  });

  /* 4. Albers: zoom by changing the SVG viewBox, so nothing is ever scaled as a bitmap */
  each('[data-lv-alb]', function (wrap) {
    var sticky = wrap.querySelector('[data-lv-alb-sticky]');
    var svg = wrap.querySelector('[data-lv-alb-svg]');
    var caps = [].slice.call(wrap.querySelectorAll('.lv-alb__cap'));
    var last = -1;
    var inner = { x: 370, y: 510, s: 260 };
    function boxes() {
      var a = Math.max(0.2, sticky.clientWidth / Math.max(1, sticky.clientHeight));
      var sw, sh, ew, eh;
      if (a >= 1) { sh = 1000; sw = 1000 * a; eh = inner.s * 0.86; ew = eh * a; } else { sw = 1000; sh = 1000 / a; ew = inner.s * 0.96; eh = ew / a; }
      return { s: { x: 500 - sw / 2, y: 500 - sh / 2, w: sw, h: sh }, e: { x: inner.x + inner.s / 2 - ew / 2, y: inner.y + inner.s / 2 - eh / 2, w: ew, h: eh } };
    }
    function capt(i) {
      if (i === last) return; last = i;
      caps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
    }
    function render() {
      var r = wrap.getBoundingClientRect();
      if (r.bottom < -50 || r.top > w.innerHeight + 50) return;
      var travel = Math.max(1, r.height - sticky.clientHeight);
      var p = Math.max(0, Math.min(1, -r.top / travel));
      var e = p * p * (3 - 2 * p), bx = boxes();
      /* zoom feels even when the size shrinks geometrically */
      var wv = bx.s.w * Math.pow(bx.e.w / bx.s.w, e), k = (wv - bx.s.w) / (bx.e.w - bx.s.w || 1);
      var x = bx.s.x + (bx.e.x - bx.s.x) * k, y = bx.s.y + (bx.e.y - bx.s.y) * k, h = bx.s.h + (bx.e.h - bx.s.h) * k;
      svg.setAttribute('viewBox', x.toFixed(2) + ' ' + y.toFixed(2) + ' ' + wv.toFixed(2) + ' ' + h.toFixed(2));
      capt(Math.min(4, Math.floor(p * 5.2)));
    }
    if (reduce) { svg.setAttribute('viewBox', '0 0 1000 1000'); capt(4); return; }
    onScroll(render); render();
  });

  /* 5. choose your night: tabs that swap picture, story and a matching review */
  each('[data-lv-chooser]', function (el) {
    var tabs = [].slice.call(el.querySelectorAll('.lv-chooser__tab'));
    function sel(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t, p = d.getElementById(x.getAttribute('aria-controls'));
        x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        if (p) p.hidden = !on;
      });
      var tray = t.parentNode;
      if (tray && tray.scrollWidth > tray.clientWidth) tray.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { sel(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); sel(tabs[(k + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); sel(tabs[(k + tabs.length - 1) % tabs.length], true); }
      });
    });
  });

  /* 6. reviews: angle first, filter, show more */
  each('[data-lv-reviews]', function (wr) {
    var grid = wr.querySelector('.lv-rgrid, .lv-qstrip');
    var pri = grid && grid.getAttribute('data-pri');
    if (pri) {
      [].slice.call(grid.querySelectorAll('.lv-rcard')).reverse().forEach(function (c) {
        if ((' ' + c.getAttribute('data-tags') + ' ').indexOf(' ' + pri + ' ') > -1) grid.insertBefore(c, grid.firstChild);
      });
      grid.scrollLeft = 0;
    }
    if (grid && grid.classList.contains('lv-qstrip')) {
      var inBox = [].map.call(d.querySelectorAll('.lv-proof__who b'), function (s) { return s.textContent.trim(); });
      if (inBox.length) [].slice.call(grid.querySelectorAll('.lv-rcard')).forEach(function (c) { var s = c.querySelector('.lv-rcard__who strong'); if (s && inBox.indexOf(s.textContent.trim()) > -1) grid.appendChild(c); });
    }
    if (grid && grid.classList.contains('lv-rgrid')) {
      /* v11.4: names already shown in the quote strip or in the buy-box reviews (lv-proof) go to the back of the grid */
      var seen = [].map.call(d.querySelectorAll('.lv-qstrip .lv-rcard:not([hidden]) .lv-rcard__who strong, .lv-proof__who b'), function (s) { return s.textContent.trim(); });
      if (seen.length) [].slice.call(grid.querySelectorAll('.lv-rcard')).forEach(function (c) { var s = c.querySelector('.lv-rcard__who strong'); if (s && seen.indexOf(s.textContent.trim()) > -1) grid.appendChild(c); });
    }
    var cards = [].slice.call(wr.querySelectorAll('.lv-rcard'));
    var step = parseInt(wr.getAttribute('data-step') || '6', 10), shown = step, filter = 'all';
    var more = wr.querySelector('[data-lv-more]');
    function render() {
      var list = cards.filter(function (c) { return filter === 'all' || (' ' + c.getAttribute('data-tags') + ' ').indexOf(' ' + filter + ' ') > -1; });
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { c.hidden = i >= shown; });
      if (more) more.hidden = list.length <= shown;
    }
    each('[data-filter]', function (b) {
      b.addEventListener('click', function () {
        each('[data-filter]', function (x) { x.setAttribute('aria-pressed', 'false'); }, wr);
        b.setAttribute('aria-pressed', 'true'); filter = b.getAttribute('data-filter'); shown = step; render();
      });
    }, wr);
    more && more.addEventListener('click', function () { shown += step * 2; render(); });
    render();
  });

  /* 7. dated delivery window */
  function dates() {
    each('[data-lv-delivery]', function (el) {
      var min = parseInt(el.getAttribute('data-min') || '8', 10), max = parseInt(el.getAttribute('data-max') || '13', 10);
      function add(n) { var t = new Date(); t.setDate(t.getDate() + n); if (t.getDay() === 0) t.setDate(t.getDate() + 1); return t; }
      var a = el.querySelector('[data-a]'), b = el.querySelector('[data-b]'), rg = el.querySelector('[data-lv-range]');
      if (a) a.textContent = day(add(min));
      if (b) b.textContent = day(add(max));
      /* one range, "and" from the locale files (lv.js.date_and); the words below only until a language has that key.
         lv11: all 23 languages, as the frames need them ("entre le ... et le ...", "między ... a ...", "med ... in ...") */
      /* abbreviation dots stay (Okt., 15. 10.); only the last one goes when the sentence itself ends with a dot */
      var lvEndDot = rg && rg.nextSibling && /^\./.test(rg.nextSibling.textContent || '');
      var lvAnd = tr('date_and', 'and') || { en: 'and', de: 'und', fr: 'et le', nl: 'en', es: 'y', it: 'e', pl: 'a', pt: 'e', cs: 'a', el: 'και', sv: 'och', nb: 'og', da: 'og', fi: 'ja', hu: 'és', ro: 'și', sk: 'a', sl: 'in', hr: 'i', bg: 'и', lt: 'ir', lv: 'un', et: 'ja' }[lang()] || 'and';
      var d1 = add(min), d2 = add(max);
      if (rg) rg.textContent = day(d1, d1.getMonth() === d2.getMonth()) + ' ' + lvAnd + ' ' + (lvEndDot ? day(d2).replace(/\.$/, '') : day(d2));
    });
    each('[data-lv-deadline]', function (el) {
      var t = new Date(); t.setDate(t.getDate() + parseInt(el.getAttribute('data-days') || '38', 10));
      /* lv11: the sentence around it comes from lv.v11.deadline_html (sections/lv-story); no double dot at the end */
      var endDot = el.nextSibling && /^\./.test(el.nextSibling.textContent || '');
      el.textContent = endDot ? day(t).replace(/\.$/, '') : day(t);
    });
  }
  dates();

  /* 8. sticky bar: "See the offer" before the buy box, "Add to cart" after it */
  (function () {
    var sticky = d.querySelector('[data-lv-sticky]');
    if (!sticky) return;
    var buy = d.querySelector('.product-form__submit');
    var box = target('lv-offer') || (buy && buy.closest('.product__info-container'));
    var hero = d.querySelector('.lv-hero, .product__media-wrapper');
    var info = sticky.querySelector('[data-lv-sticky-title]'), price = sticky.querySelector('[data-lv-sticky-price]');
    var btn = sticky.querySelector('[data-lv-sticky-add]');
    var mode = null;
    function sync() {
      var s = d.querySelector('.kaching-bundles__bar--selected');
      if (!s) return false;
      var t = s.querySelector('.kaching-bundles__bar-title'), p = s.querySelector('.kaching-bundles__bar-price');
      if (t && info && info.textContent !== t.textContent.trim()) info.textContent = t.textContent.trim();
      if (p && price && price.textContent !== p.textContent.trim()) price.textContent = p.textContent.trim();
      return !!(t && p);
    }
    /* the sticky bar follows every tier change, however it was made */
    function later() { setTimeout(sync, 40); setTimeout(sync, 400); }
    d.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('kaching-bundles-block')) later(); }, true);
    d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.kaching-bundles__bar')) later(); }, true);
    var kb = d.querySelector('kaching-bundles-block');
    if (kb && 'MutationObserver' in w) new MutationObserver(sync).observe(kb, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    setTimeout(sync, 1500);
    var n = 0, iv = setInterval(function () { if (sync() || ++n > 60) clearInterval(iv); }, 1000);
    function setMode(m) {
      if (m) sync();
      if (m === mode) return; mode = m;
      sticky.classList.toggle('is-on', !!m);
      /* both labels live in the markup (translated by the theme locale files); only a class changes here */
      if (m) sticky.classList.toggle('is-add', m === 'add');
    }
    function check() {
      var vh = w.innerHeight;
      /* v9: never in the first screen; only once the visitor has scrolled past the hero */
      var heroEnd = hero ? hero.getBoundingClientRect().bottom + w.pageYOffset : 0;
      var past = w.pageYOffset > Math.max(vh * 0.9, heroEnd - 40);
      if (!box) { setMode(past ? 'go' : ''); return; }
      var kbx = d.querySelector('kaching-bundles-block');
      var top = (kbx || box).getBoundingClientRect().top, bot = (buy || box).getBoundingClientRect().bottom;
      if (!past) setMode('');
      else if (bot < 0) setMode('add');             /* the real button has left the screen upwards */
      else if (top < vh && bot > 0) setMode('');    /* sets or button on screen: stay out of the way */
      else setMode(top > vh + 120 ? 'go' : '');
    }
    onScroll(check); check();
    /* v9: "Add to cart" really adds the chosen set (then lv9.js takes the visitor to checkout); before the buy box it scrolls there */
    function addNow(tries) {
      if (buy && !buy.disabled) { btn.classList.add('lv9-busy'); buy.click(); return; }
      if (buy && tries < 20) { setTimeout(function () { addNow(tries + 1); }, 100); return; }
      w.location.href = root() + 'products/lampiero-670nm-red-night-light-portable-bedside-sleep-lamp#lv-offer';
    }
    btn && btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (mode === 'add') addNow(0);
      else if (box) go(offer() || box);
      else w.location.href = root() + 'products/lampiero-670nm-red-night-light-portable-bedside-sleep-lamp#lv-offer';
    });
    var gi = sticky.querySelector('[data-lv-sticky-go]');
    gi && gi.addEventListener('click', function () { go(offer() || box); });
  })();

  /* 9. cart drawer: under Kaching's own tip, give people a reason for a second lamp */
  (function () {
    var note = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg><span></span>';
    var noteText = T.cart_note || 'Almost 1 in 3 customers take two or more: one for a partner, a child\'s room, the hallway or the bathroom.';
    function add() {
      each('#kaching-cart .kaching-cart-item__bundle-tips', function (t) {
        var boxEl = t.parentNode, item = t.closest('.kaching-cart-item');
        var q = item && item.querySelector('.kaching-cart-item__quantity-input');
        var one = q && parseInt(q.value || q.textContent || '0', 10) === 1;
        var has = boxEl && boxEl.querySelector('.lv-cart-note');
        if (boxEl && one && !has) { var p = d.createElement('p'); p.className = 'lv-cart-note'; p.innerHTML = note; p.querySelector('span').textContent = noteText; boxEl.insertBefore(p, t.nextSibling); }
        else if (has && !one) has.parentNode.removeChild(has);
      });
    }
    if ('MutationObserver' in w) {
      var busy = false, mo = new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { busy = false; add(); }); });
      var start = function () { mo.observe(d.body, { childList: true, subtree: true }); add(); };
      if (d.body) start(); else d.addEventListener('DOMContentLoaded', start);
    }
  })();

  /* 10. in-page links: always land on something visible */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var t = id === 'lv-offer' ? offer() : target(id);
    if (t) { e.preventDefault(); go(t); if (history.replaceState) history.replaceState(null, '', '#' + id); }
  });

  /* 11. Turrell band: fixed picture behind a window, as on the live theme. Only shown near view, so it never loads early. */
  each('.lv-art', function (el) {
    if (!('IntersectionObserver' in w)) { el.classList.add('is-near'); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { el.classList.toggle('is-near', e.isIntersecting); });
    }, { rootMargin: '200% 0px 200% 0px' }).observe(el);
  });


  /* v4-1. footnotes open the folded sources before scrolling to them */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#lv-src"]');
    if (!a) return;
    var box = d.getElementById('lv-src');
    if (box && box.tagName === 'DETAILS') box.open = true;
  }, true);

  /* v4-2. choose your night: fetch every picture once the section is near, so a tap never waits for the network */
  each('[data-lv-chooser]', function (el) {
    function warm() { each('img', function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); }, el); }
    if (!('IntersectionObserver' in w)) { warm(); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); warm(); } }, { rootMargin: '250px 0px' });
    io.observe(el);
  });
  each('[data-lv-sw]', function (el) {
    if (!('IntersectionObserver' in w)) return;
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); each('img', function (im) { im.loading = 'eager'; }, el); } }, { rootMargin: '250px 0px' });
    io.observe(el);
  });

  /* v4-3. sets: a per-lamp price under every Kaching price, and the reasons that pick a set */
  (function () {
    /* lv11: parse and print amounts with assets/lv-money.js (page language; "1,008 zł" is 1008, not 1) */
    function num(t) { if (w.lvMoney) { var x = w.lvMoney.parse((t || '').replace(/[^\d.,\s\u00a0\u202f]/g, '')); return isNaN(x) ? 0 : x; } var m = (t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{1,2})?)/); return m ? parseFloat(m[1].replace(',', '.')) : 0; }
    function fmt(txt, v) { var cur = (txt || '').replace(/[\d.,\s]/g, '') || '€'; var n = Math.round(v); var c = /zł/.test(cur) ? 'PLN' : /Kč/.test(cur) ? 'CZK' : /€/.test(cur) ? 'EUR' : null; var o = c && w.lvMoney && w.lvMoney.fmt(n, c); if (o) return o; var s = /^\d/.test((txt || '').trim()) ? n + ' ' + cur : cur + n; return w.lvMoney && w.lvMoney.fix ? w.lvMoney.fix(s) : s; } /* pack1 (19 Oct): kr and lei as lv-money.js prints them */
    function perLamp() {
      each('.kaching-bundles__bar', function (bar) {
        var bars = [].slice.call(bar.parentNode.querySelectorAll('.kaching-bundles__bar'));
        var q = bars.indexOf(bar) + 1;
        if (w.lv8Qty) q = w.lv8Qty(bar, q - 1);
        var pr = bar.querySelector('.kaching-bundles__bar-price');
        var box = bar.querySelector('.kaching-bundles__bar-pricing');
        if (!pr || !box || q < 3) return;
        var v = num(pr.textContent); if (!v) return;
        /* content rule 27 Sep: the price 59 never appears on the site, so a per-lamp figure of 59 is never printed */
        if (Math.round(v / q) === 59) return;
        var lb = bar.querySelector('.kaching-bundles__bar-label');
        if (lb && lb.textContent.indexOf(String(Math.round(v / q))) > -1) return;
        var eachTpl = T.price_each || '[price] each', txt = eachTpl.indexOf('[price]') > -1 ? eachTpl.replace('[price]', fmt(pr.textContent, v / q)) : fmt(pr.textContent, v / q) + ' ' + eachTpl;
        var el = box.querySelector('.lv-each');
        if (!el) { el = d.createElement('span'); el.className = 'lv-each'; box.appendChild(el); }
        if (el.textContent !== txt) el.textContent = txt;
      });
    }
    function pick(q) {
      var bars = d.querySelectorAll('.kaching-bundles__bar');
      var bar = bars[q - 1]; if (!bar) return false;
      var lab = bar.querySelector('label') || bar.querySelector('.kaching-bundles__bar-main');
      lab && lab.click();
      return true;
    }
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lv-set]');
      if (!b) return;
      e.preventDefault();
      var q = parseInt(b.getAttribute('data-lv-set'), 10);
      if (pick(q)) {
        each('[data-lv-set]', function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      }
    });
    /* the four set cards pick the matching tier on their way to the offer */
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.lv-set');
      if (!a) return;
      var all = [].slice.call(a.parentNode.querySelectorAll('.lv-set'));
      var q = all.indexOf(a) + 1;
      if (q > 0) setTimeout(function () { pick(q); each('[data-lv-set]', function (x) { x.setAttribute('aria-pressed', 'false'); }); }, 400);
    });
    var kb = d.querySelector('kaching-bundles-block');
    if (kb && 'MutationObserver' in w) { var busy = false; new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { busy = false; perLamp(); }); }).observe(kb, { subtree: true, childList: true, characterData: true }); }
    setTimeout(perLamp, 1200); setTimeout(perLamp, 3000);
  })();

  /* v4-4 (moving the Weglot language pill into the footer) is gone in v10: the language switch is the theme's own (lv9.js) */


  /* v5-1. the guarantee deadline is written by dates() above (same language rules as the delivery window) */

  /* v5-2. copy a link (birth lists) */
  each('[data-lv-copy]', function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-lv-copy'), ca = b.querySelector('.lv-cp-a'), cb = b.querySelector('.lv-cp-b');
      function ok() { if (!ca || !cb) return; ca.hidden = true; cb.hidden = false; setTimeout(function () { ca.hidden = false; cb.hidden = true; }, 2200); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(ok, function () { w.prompt(T.copy_link || 'Copy this link', v); });
      else { w.prompt(T.copy_link || 'Copy this link', v); }
    });
  });

  /* v5-4. "Translated from German" is noise for a German reader: hide the label in the reader's own language.
     v10: the card carries data-from in the markup; the English text is read only for cards without it */
  (function () {
    var map = { Dutch: 'nl', German: 'de', French: 'fr', Italian: 'it', Spanish: 'es', Portuguese: 'pt', Polish: 'pl', Swedish: 'sv', Danish: 'da', Finnish: 'fi', Czech: 'cs' };
    each('.lv-rcard__tr:not([data-from])', function (t) { var m = /from (\w+)/.exec(t.textContent); if (m && map[m[1]]) t.setAttribute('data-from', map[m[1]]); });
    function run() { var l = lang(); each('.lv-rcard__tr[data-from]', function (t) { t.hidden = t.getAttribute('data-from') === l; }); }
    run();
  })();

  /* v5-3. the 26 flags once per page: keep the first strip, hide the rest */
  (function () { var f = d.querySelectorAll('.lv-countries'); for (var i = 1; i < f.length; i++) f[i].hidden = true; })();

  if (raf === 0) raf = requestAnimationFrame(loop);
})();
